import request from '../utils/fetch'

// 密码登录
export const login = (data, param) => request('/front/login/normal', data, 'QUERYPOST', param)

export default {
  login
};
